<template>
  <div>
    <div
      v-for="company in children"
      :key="company.id"
      class="choose-team-list"
    >
      <div
        class="title-flex"
        :class="{ 'selected': isChildrenVisible(company), 'current': company.id === childrenActiveId }"
        @click="selectCompany(company, true)"
      >
        <!-- Parent company item -->
        <div class="title-and-rond">
          <div class="rond" :class="{ 'hidden': hasToSelectLeaf && company.children.length, 'on': company.id === childrenActiveId }">
            <div class="loading">
              <div class="loader"/>
            </div>
          </div>
          <div class="title-container">
            <div class="title">
              <span v-if="nameParts(company).lead" class="title-prefix title-prefix--lead">{{ nameParts(company).lead }}</span>
              <span v-if="nameParts(company).prefix" class="title-prefix">{{ nameParts(company).prefix }}</span>
              <MiddleEllipsis :text="nameParts(company).rest" />
            </div>
          </div>
          <div v-if="customerKpiStore.accountCount(company.id, counter)" class="pending-badge">
            {{ customerKpiStore.accountCount(company.id, counter) }}
          </div>
          <div v-if="company.children.length" class="arrow-and-text">
            <div class="text-before-arrow">{{ company.children.length }} {{ `team${company.children.length > 1 ? 's' : ''}` }}</div>
            <div class="arrow-drop-container">
              <el-icon class="el-icon-arrow-down" :class="{ active: childrenVisibility[company.id] }"><arrow-down /></el-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- Recursive call for displaying nested children companies -->
      <div
        v-if="company.children.length && childrenVisibility[company.id]"
        ref="childrenList"
        class="children-list"
      >
        <recursive-team-list
          :has-to-select-leaf="hasToSelectLeaf"
          :parent-name="company.name"
          :counter="counter"
          :children="company.children"
          @company-selected="selectCompany"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { useCompanyStore } from '@/stores/company';
import { useCustomerKpiStore } from '@/stores/customerKpi';
import MiddleEllipsis from '@/components/Global/MiddleEllipsis';
import { sharedNamePrefix, splitName } from '@/utils/accountNamePrefix';

export default {
  name: 'recursiveTeamList',
  components: { MiddleEllipsis },
  props: ['children', 'hasToSelectLeaf', 'parentName', 'counter'],
  data() {
    return {
      childrenVisibility: {}, // Store the visibility state for each parent
    };
  },
  computed: {
    ...mapStores(useAuthStore, useCompanyStore, useCustomerKpiStore),
    namePrefix() {
      return sharedNamePrefix(this.children.map((company) => company.name), this.parentName);
    },
    childrenActiveId() {
      return this.companyStore.childrenCompany ? this.companyStore.childrenCompany.id : null;
    },
  },
  methods: {
    nameParts(company) {
      return splitName(company.name, this.namePrefix);
    },
    isChildrenVisible(company) {
      // Check if the children should be visible for the given parent
      return this.childrenVisibility[company.id];
    },
    selectCompany(company, forceSelectCompany) {
      if (!company.children.length || (forceSelectCompany && !this.hasToSelectLeaf)) {
        this.$emit('company-selected', company, forceSelectCompany);
        if (company.children.length) {
          this.childrenVisibility = { ...this.childrenVisibility, [company.id]: true };
        }
      } else {
        // Toggle the visibility state for the clicked parent
        this.childrenVisibility = {
          ...this.childrenVisibility,
          [company.id]: !this.isChildrenVisible(company),
        };
      }
    },
  },
};
</script>
